import { useMemo, useState } from 'react'
import { OrgOption } from '../types'

export function useOrganizationHierarchy(options: OrgOption[]) {
  const defaultOption = useMemo(() => {
    return (
      options.find((o) => o.value.type) || {
        label: 'Platform',
        value: {
          id: 'all-users',
          type: 'Account',
          brokerageId: null,
          usersCount: 0
        }
      }
    )
  }, [options])

  const [hierarchy, setHierarchy] = useState<OrgOption[]>([defaultOption])
  const [hierarchyInView, setHierarchyInView] =
    useState<OrgOption>(defaultOption)

  const brokerageOptions = useMemo(() => {
    return options.filter((o) => o.value.type === 'Brokerage')
  }, [options])

  const officesWithoutBrokerage = useMemo(() => {
    return options.filter(
      (o) => o.value.type === 'Office' && !o.value.brokerageId
    )
  }, [options])

  const officeOptions = useMemo(() => {
    return options.filter(
      (option) =>
        option.value.type === 'Office' &&
        option.value.brokerageId &&
        hierarchyInView.value.id.includes(`b-${option.value.brokerageId}`)
    )
  }, [options, hierarchyInView])

  const teamOptions = useMemo(() => {
    return options.filter(
      ({ value }) =>
        hierarchyInView.value.type === 'Office' &&
        value?.primaryOfficeId === hierarchyInView.value.id.split('-')[1]
    )
  }, [options, hierarchyInView])

  return {
    hierarchy,
    hierarchyInView,
    brokerageOptions,
    officesWithoutBrokerage,
    officeOptions,
    teamOptions,
    defaultOption,
    hasBrokerage: hierarchy[hierarchy.length - 1]?.value.type === 'Brokerage',
    hasTeams: teamOptions.length > 0,
    setHierarchy,
    setHierarchyInView
  }
}
